import { computed, onMounted } from 'vue'
import { useRecipeStore } from '@/stores/recipeStore.js'
import { DateTime } from 'luxon'

export default {
  name: 'RecipeEdit',
  props: ['id'],
  setup(props) {
    const recipeStore = useRecipeStore() // Assuming you have a recipe store defined
    const recipeId = props.id

    const recipe = computed(() => {
      return recipeStore.recipe
    })

    onMounted(async () => {
      await recipeStore.fetchRecipeById(recipeId)
    })

    function getNiceDate(date) {
      if (!date) return ''
      const dt = DateTime.fromJSDate(new Date(date))
      return dt.toFormat('dd.MM.yyyy HH:mm')
    }

    function removeIngredient(index) {
      recipe.value.ingredients.splice(index, 1)
    }

    function addIngredient() {
      recipe.value.ingredients.push('')
    }

    function removeInstruction(index) {
      recipe.value.instructions.splice(index, 1)
    }

    function addInstruction() {
      recipe.value.instructions.push('')
    }

    function viewRecipe() {
      window.location.href = `/recipes/${recipeId}`
    }

    async function removeRecipe() {
      await recipeStore.removeRecipe(recipeId)
    }

    async function updateRecipe() {
      await recipeStore.updateRecipe(recipe.value)
    }

    return {
      getNiceDate,
      recipeId,
      recipe,
      viewRecipe,
      removeIngredient,
      addIngredient,
      addInstruction,
      removeInstruction,
      removeRecipe,
      updateRecipe,
    }
  },
}
